// src/modules/app-views/toolbox/pages/Document/tabs/ManagementTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleCurrency from 'components/SimpleComponents/SimpleCurrency';
import SimpleDatePicker from 'components/SimpleComponents/SimpleDatePicker';
import SimpleSelectAsync from 'components/SimpleComponents/SimpleSelectAsync';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ToolboxManagementTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext() || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const conditionOptions = [
    { value: 'new', label: translateX('new') },
    { value: 'good', label: translateX('good') },
    { value: 'fair', label: translateX('fair') },
    { value: 'worn', label: translateX('worn') },
    { value: 'damaged', label: translateX('damaged') },
    { value: 'decommissioned', label: translateX('decommissioned') },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="toolboxManagement" isFetching={loading} data={data} />

      {/* ACQUISITION CARD */}
      <Card title={<div className="text-muted">{translateX('acquisition')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={8}>
            <SimpleCurrency
              name="acquisitionCost"
              label="acquisition_cost"
              currencies={[{ value: 'BRL', label: 'R$', text: 'Real Brasileiro' }]}
            />
          </Col>

          <Col xs={24} sm={8}>
            <SimpleDatePicker name="acquisitionDate" label="acquisition_date" />
          </Col>

          <Col xs={24} sm={8}>
            <SimpleSelect
              name="condition"
              label="condition"
              options={conditionOptions}
              allowClear
            />
          </Col>
        </Row>

        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={12}>
            <SimpleInput name="serialNumber" label="serial_number" />
          </Col>

          <Col xs={24} sm={12}>
            <SimpleInput name="location" label="location" />
          </Col>
        </Row>

        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={12}>
            <SimpleSelectAsync
              name="assignedToEntityId"
              label="assigned_to"
              module="entities"
              allowClear
            />
          </Col>
        </Row>
      </Card>

      {/* CALIBRATION CARD */}
      <Card title={<div className="text-muted">{translateX('calibration')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={12}>
            <SimpleDatePicker name="lastCalibration" label="last_calibration" />
          </Col>

          <Col xs={24} sm={12}>
            <SimpleDatePicker name="nextCalibration" label="next_calibration" />
          </Col>
        </Row>

        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleInput name="maintenanceNotes" label="maintenance_notes" type="textarea" rows={4} />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ToolboxManagementTab;

// *******************************************************************************
// HELPERS
// *******************************************************************************
